export const setColor = (name: string, value: string | number) => {
  return {[name]: '#' + value}
}
